import type {PurchaseBatch} from './governanceTypes';
import {batchReference} from './purchaseBatchPresentation';
export function PurchaseBatchIdentity({batch}:{batch:PurchaseBatch}) {
  return <span className="op-batch-identity"><strong>{batch.stockPointName}</strong><span>{batchReference(batch)}</span></span>;
}
